import { render, staticRenderFns } from "./gubatab.vue?vue&type=template&id=df051542&scoped=true&"
import script from "./gubatab.vue?vue&type=script&lang=js&"
export * from "./gubatab.vue?vue&type=script&lang=js&"
import style0 from "./gubatab.vue?vue&type=style&index=0&id=df051542&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df051542",
  null
  
)

export default component.exports